module.exports = __webpack_public_path__ + "static/img/guide-bg.4c53cb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guide-bg.png
// module id = pAae
// module chunks = 0